import { capitalize, get } from 'lodash';

import { notNil } from '@/lib/utils';
import { Icon } from '@/components/icon';

import { List, ListItem } from '../common';
import { getCreatedAtLabel } from '../utils';

import { getIntegrationIcon } from './utils';

import styles from './integrations.module.scss';

export interface IntegrationListItem {
  integrationId: string;
  createdAt: string;
  service: string;
  name?: string | null;
  url?: string | null;
  workspaceId?: string | null;
}

interface IntegrationListProps {
  integrations: IntegrationListItem[];
}

const IntegrationServiceNameMap = {
  FACEBOOK_ADS: 'Facebook Ads',
  FACEBOOK_PAGE: 'Facebook Page',
  GOOGLE_ANALYTICS: 'Google Analytics',
  GOOGLE_ADS: 'Google Ads',
  GOOGLE_BIGQUERY: 'Google BigQuery',
  GOOGLE_DRIVE: 'Google Drive',
};

export const IntegrationList = (props: IntegrationListProps) => {
  const getUrl = (integration: IntegrationListItem) => {
    if (integration.service === 'SLACK') {
      return `https://app.slack.com/client/${integration.workspaceId}/`;
    }
  };

  return (
    <List numColumns={2}>
      {props.integrations
        .map((item) => ({
          ...item,
          label: get(
            IntegrationServiceNameMap,
            item.service,
            capitalize(item.service.replace(/_/g, ' ')),
          ),
          icon: getIntegrationIcon(item.service),
          url: item.url ?? getUrl(item),
        }))
        .map(({ label, service, name, url, createdAt, icon }, i) => (
          <ListItem key={i}>
            <div className={styles.name}>
              {icon !== undefined && <Icon name={icon} size={service === 'NOTION' ? 18 : 20} />}
              {label}
              {notNil(name) && <span className={styles.subtitle}>({name})</span>}
              {notNil(url) && (
                <a href={url} target="_blank" rel="noreferrer" className={styles.subtitle}>
                  <Icon name="Link" size={12} />
                </a>
              )}
            </div>
            <div className={styles.createdAt}>{getCreatedAtLabel(createdAt)}</div>
          </ListItem>
        ))}
    </List>
  );
};
